import Icon from '../../components/Icon.vue'

Icon.register({"brands/twitter":{"width":512,"height":512,"paths":[{"d":"M459.4 151.7C459.7 156.3 459.7 160.8 459.7 165.4 459.7 304.1 354.1 463.9 161.1 463.9 101.7 463.9 46.5 446.7 0 416.8 8.4 417.8 16.6 418.1 25.3 418.1 74.4 418.1 119.6 401.5 155.6 373.3 109.5 372.3 70.8 342.1 57.5 300.5 64 301.5 70.5 302.1 77.3 302.1 86.7 302.1 96.2 300.8 104.9 298.6 56.9 288.8 20.8 246.6 20.8 195.6V194.3C34.8 202.1 51 206.9 68.2 207.6 40 188.8 21.4 156.6 21.4 120.2 21.4 100.7 26.6 82.8 35.7 67.2 87.4 130.9 165 172.5 252.1 177.1 250.5 169.3 249.5 161.1 249.5 153 249.5 95.2 296.3 48.1 354.4 48.1 384.6 48.1 411.9 60.8 431.1 81.2 454.8 76.7 477.6 67.9 497.7 55.9 489.9 80.2 473.3 100.7 451.6 113.7 472.7 111.4 493.2 105.6 512 97.5 497.7 118.3 479.8 136.8 459.4 151.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/twitter.js
// module id = null
// module chunks = 